<template>
  <Banner>
    <img src="../assets/img/banner-small.jpg" alt="contact-us" name="Contact Us" style="width: 100%;max-height: 650px">
  </Banner>
  <div class="product">
    <div class="side-bar">
      <header> <i class="iconfont icon-product_a" /> Product</header>
      <ul class="nav">
        <li class="nav-item" v-for="(item, index) in products" :key="index">
          <div class="nav-item-wrapper">
            <nuxt-link :to="item.url" class="nav-item-title">
              {{ item.title }}
            </nuxt-link>
          </div>
        </li>
      </ul>
    </div>
    <div class="product-main">
      <nuxt-page />
    </div>
  </div>
</template>

<script setup lang="ts">
import {nav, products} from "~/data/data"
import {useRoute} from "vue-router"

useHead({
  title: 'product',
  meta: [{
    name: 'description',content: 'product description of RCH, includes underwater cameras, underwater video accessories, underwater illumination, underwater gimbal, underwater pan/tilts, underwater optical transceivers, underwater connectors, underwater manipulators, underwater laser and so on'
  }]
})
const route = useRoute()

onMounted(() => {
  init()
})
onUpdated(() => {
  init()
})
function init() {
  /*  const fullPath = route.fullPath
  if(fullPath === '/product/smd-agriculture' || fullPath.indexOf('/product/detail/ag') != -1) {
     handleClick(12)
     return
   }
   if(fullPath === '/product/smd-automotive'|| fullPath.indexOf('/product/detail/auto') != -1) {
     handleClick(13)
     return
   }
   if(fullPath === '/product/smd-medical'|| fullPath.indexOf('/product/detail/med') != -1) {
     handleClick(14)
     return
   }
   if(fullPath === '/product/smd-industrial'|| fullPath.indexOf('/product/detail/ind') != -1) {
     handleClick(15)
     return
   }
   let pathPrefix = fullPath.split('-')[0]
   if (pathPrefix.indexOf('detail') != -1) {
     pathPrefix = pathPrefix.replace('/detail','')
   }
   const routeIndex = products.findIndex(item => item.url === pathPrefix)*/
}
</script>

<style lang="stylus" scoped>
.product
  max-width 1510px
  min-width 1280px
  height 100%
  margin 40px auto
  padding 0 50px
  box-sizing border-box
  display flex
  .side-bar
    width 300px
    header
      background #077090
      opacity .8
      height 55px
      color #FFF
      text-align left
      line-height 55px
      font-size 30px
      font-weight 300
      padding 0 20px
      display flex
      align-items center
      &>i
        color #FFF
        font-size 22px
        margin-right 8px
    .nav
      border 1px solid #EEE
      border-bottom none
      &-item
        line-height 20px
        &:hover .nav-item-title
          color #1e8bac
        &-wrapper
          display flex
          align-items center
          border-bottom 1px solid #EEE
          justify-content space-between
          .router-link-active
            color: #1e8bac!important
          .nav-item-title
            display block
            padding 20px
            box-sizing border-box
            color #666
          .icon-jiantouxia
            margin-right 10px
            cursor pointer
        .sub-nav
          transition all .3s linear
          height 0
          overflow hidden
          background #f7f7f7
          &-item
            height 35px
            line-height 35px
            .sub-nav-item-title
              display inline-block
              padding-left 2em
              color #666
  .product-main
    flex 1
    margin-left 20px
</style>
